import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../calendar/css/DatePicker.css';
import { useTranslation, Trans } from 'react-i18next';
import useDates from '../../hooks/useDates';

const number = "+50687651670";

const ReservationModal = ({ houseName }) => {
    const { t } = useTranslation();
    const { button, locale, cancel } = t("datepicker.calendar");
    const { title } = t("datepicker.form")
    const beginReservation = t("datepicker.reservation.button");
    const { form } = t("datepicker");

    const { addDays } = useDates();

    const [name, setName] = useState('');
    const [dates, setDates] = useState([null, null]);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [guests, setGuests] = useState(2);
    const [errors, setErrors] = useState({});
    const [showDoubleView, setShowDoubleView] = useState(window.innerWidth > 768);
    const minDate = addDays(new Date(), 1);

    useEffect(() => {
        const handleResize = () => {
            setShowDoubleView(window.innerWidth > 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const validate = () => {
        const newErrors = {};
        if (!name) newErrors.name = form.name.error;
        if (!dates[0]) newErrors.arrivalDate = form.dates.errorArrivalDate;
        if (!dates[1]) newErrors.departureDate = form.dates.errorDepartureDate;
        if (dates[0] && dates[1]) {
            const arrival = new Date(dates[0]);
            const departure = new Date(dates[1]);
            const diffTime = Math.abs(departure - arrival);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (arrival >= departure) {
                newErrors.departureDate = form.dates.errorDates;
            } else if (diffDays < 3) {
                newErrors.departureDate = form.dates.minimumStay;
            }
        }

        if (!guests) {
            newErrors.guests = form.guests.error;
        }

        if (!email) {
            newErrors.email = form.email.error;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = form.email.invalid;
        }

        if (!phone) {
            newErrors.phone = form.phone.error;
        }
        else if (!/^\+\d{3}\d{7,14}$/.test(phone) && !/^(00\d{3})\d{7,14}$/.test(phone)) {
            newErrors.phone = form.phone.invalid.map((text) => <>
                <div>{text}</div>
            </>);
        }
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
            const message = `Nombre: ${name}\n Fecha de llegada: ${dates[0].toLocaleDateString('es-ES', options)}\n Fecha de salida: ${dates[1].toLocaleDateString('es-ES', options)}\n Correo: ${email}\n Teléfono: ${phone} \n Número de personas: ${guests} Cabaña: ${houseName}`;
            const url = `https://wa.me/${number}/?text=${encodeURI(message)}`;
            window.open(url, '_blank');
            setName('');
            setDates([null, null]);
            setEmail('');
            setPhone('');
            setErrors({});
            setGuests(2);
            const btnModal = document.getElementById("formModalBtnClose");
            btnModal.click();
        }
    };

    return (
        <>
            <button type="button" id="formModalBtnClose" className="jobos-btn py-3 px-5 mt-5" data-bs-toggle="modal" data-bs-target="#reservationModal">
                {beginReservation}
            </button>
            <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="reservationModal" tabIndex="-1" aria-labelledby="reservationModal">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen ">
                    <div className="modal-content bg-black-transparent border-0">
                        <div className="modal-body">
                            <div className='d-flex flex-column justify-content-center h-100'>
                                <div style={{ width: "auto", maxHeight: "90vh", overflowY: "auto", overflowX: "hidden" }} className="bg-body rounded-3 mx-auto">
                                    {/* <div className='d-flex justify-content-start w-100 ps-3 pt-4'>
                                        <button type="button" classNzme="btn-close" data-bs-toggle="modal" data-bs-target="#reservationModal" aria-label="Close"></button>
                                    </div> */}
                                    <form onSubmit={handleSubmit} className={`p-4`}>
                                        <div className='d-flex justify-content-center'>
                                            <p className={`fw-bold lh-30 ls-2 fs-20 text-jobos-brown text-center`} style={{ maxWidth: "400px" }}>{title}</p>
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="name" className="form-label">{form.houseName.label}:</label>
                                            <input type="text" disabled className="form-control" id="houseName" value={houseName} />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="name" className="form-label">{form.name.label}:</label>
                                            <input type="text" className="form-control" id="name" value={name} onChange={(e) => setName(e.target.value)} />
                                            {errors.name && <div className="text-danger">{errors.name}</div>}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label">{form.email.label}:</label>
                                            <input className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                            {errors.email && <div className="text-danger">{errors.email}</div>}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="phone" className="form-label">{form.phone.label}:</label>
                                            <input className="form-control" type='tel' id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                            {errors.phone && <div className="text-danger">{<Trans>{errors.phone}</Trans>}</div>}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="number" className="form-label">{form.guests.label}:</label>
                                            <input className="form-control" type='number' id="phone" value={guests} onChange={(e) => setGuests(e.target.value)} />
                                            {errors.guests && <div className="text-danger">{<Trans>{errors.guests}</Trans>}</div>}
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="dates" className="form-label">{form.dates.label}:</label>
                                            <Calendar
                                                locale={locale}
                                                onChange={setDates}
                                                value={dates}
                                                selectRange={true}
                                                showDoubleView={showDoubleView}
                                                minDate={minDate}
                                                className="form-control"
                                            />
                                            {errors.arrivalDate && <div className="text-danger">{errors.arrivalDate}</div>}
                                            {errors.departureDate && <div className="text-danger">{errors.departureDate}</div>}
                                        </div>
                                        <div className='d-flex justify-content-xl-between justify-content-center align-items-center flex-column-reverse flex-xl-row'>
                                            <button type="button" className="dp-btn-cancel mt-4 mt-xl-0" data-bs-toggle="modal" data-bs-target="#reservationModal">
                                                {cancel}
                                            </button>
                                            <button type="submit" className="dp-btn mt-3 mt-xl-0">{button}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReservationModal;